import Api from '@/services/api'
import jsonSegmento from "@/repositories/fake/antecipacao/segmentos.json"
import jsonPrevia from "@/repositories/fake/antecipacao/previa.json"
import jsonAntecipacao from "@/repositories/fake/antecipacao/antecipacao.json"

let loadingRequisicao = true
export default {
   
  async fetch ({ aba, classe, index, form }) {
    
    if(loadingRequisicao){
      loadingRequisicao = false
     // console.log(aba, classe, index, form)
      let url = null
  
      if (classe == 'icms') {
        url = 'Tributos/ObterIcmsComplemento'
      }
  
      if (classe == 'carga_liquida') {
        url = 'Tributos/ObterCargaLiquida'
      }
  
      if (aba == 'antecipacao' && index == 'previa') {
        url = 'Tributos/ObterAntecipacao'
        // url = 'Tributos/ObterCargaLiquida'
      }
  
      if (aba == 'antecipacao' && index == 'antecipacao') {
        url = 'Tributos/ObterAntecipacao'
        // url = 'Tributos/ObterCargaLiquida'
      }
  
      if (aba == 'difal' && index == 'difal') {
        url = 'Tributos/ObterDifal'
        // url = 'Tributos/ObterCargaLiquida'
      }
  
      if (aba == 'difal' && index == 'difal-nao-contribuinte') {
        url = 'Tributos/ObterDifal'
      }
  
      // fake
      if (form.fake == true && aba == 'antecipacao') {
        if (aba == 'antecipacao' && index == 'segmento') {
          console.log('fake antecip segmento')
          loadingRequisicao =true 
          return jsonSegmento.dados
        }
  
        if (aba == 'antecipacao' && index == 'previa') {
          console.log('fake antecip previa')
          loadingRequisicao =true 
          return jsonPrevia.dados
        }
  
        if (aba == 'antecipacao' && index == 'antecipacao') {
          console.log('fake antecip antecipacao')
          loadingRequisicao =true 
          return jsonAntecipacao.dados
        }
      }
  
      //Fake Difal
      if(form.fake == true && aba == 'difal') {
        if (aba == 'difal' && index == 'difal') {
          console.log('fake difal contribuinte')
          url = 'Tributos/ObterAntecipacao'
        }
      }
  
      if (!url) {   
        loadingRequisicao =true  
        return []
      }
  
      const response = await new Api().post(url, form)
      
      loadingRequisicao =true 
      return response.dados.dados
    }
  }
}
